import React from 'react';
import {Navbar} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AiOutlineLogout } from 'react-icons/ai';

function Nav(props) {

  return (
    <>
    <Navbar className="navbar-inverse justify-content-center">
          <Navbar.Collapse className={props.isLogin ? '' : 'mr-5' }></Navbar.Collapse>
          <Navbar.Brand href="#" className="justify-content-end"><img
            src="/logotipo300.png"
            width="auto"
            height="35"
            className="d-inline-block align-top"
            alt="EntradaWeb"
          /></Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <Link to="/logout" className="logout-link" hidden={props.isLogin}>
              <AiOutlineLogout size={25} ></AiOutlineLogout>
            </Link>
          </Navbar.Collapse>
      </Navbar>
      <div className="tituloSuperior text-center">
            <p>Control de Acceso</p>
      </div>
      </>
  );
}

export default Nav;